export default "__VITE_ASSET__BfLhN_QO__"